import React from 'react';
import { borders, spaces, typography } from '@99designs/ui/settings';
import Box from 'libs/core-components/Box/Box';
import IconButton from 'microfrontend/common/components/IconButton';
import { IconX1 } from '@99designs/icons';

export interface BaseAlertProps {
    icon?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
    onDismiss?: () => void;
    dismissed?: boolean;
}

export default function BaseAlert({
    className,
    children,
    icon,
    onDismiss,
    dismissed = false,
}: BaseAlertProps) {
    const hide = () => {
        if (onDismiss) {
            onDismiss();
        }
    };

    if (dismissed) return null;

    return (
        <Box
            display="flex"
            css={`
                padding: ${spaces.space6}px ${spaces.halfGutter}px;
                border-radius: ${borders.borderRadiuses.medium}px;
            `}
            className={className}
            data-testid={'BaseAlert'}
        >
            <Box marginRight="space6">{icon}</Box>
            <div
                css={`
                    line-height: ${typography.lineHeights.root};
                    font-size: ${typography.fontSizes.root}px;
                    margin: 0;
                    flex-grow: 1;
                `}
            >
                {children}
            </div>
            {onDismiss && (
                <Box marginLeft="space6">
                    <IconButton aria-label={__('Dismiss')} onClick={hide}>
                        <IconX1 />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}
